import { render, staticRenderFns } from "./BaseBannerTitle.vue?vue&type=template&id=31065ab6&"
import script from "./BaseBannerTitle.vue?vue&type=script&lang=js&"
export * from "./BaseBannerTitle.vue?vue&type=script&lang=js&"
import style0 from "./BaseBannerTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports